import React, { useContext } from 'react';
import chromeHilightedLock from '../../assets/images/chromeHilightedLock.png';
import chromePermissionsBlocked from '../../assets/images/chromePermissionsBlocked.png';
import chromeLocationToggle from '../../assets/images/chromeLocationToggle.png';
import safariHilightedAa from '../../assets/images/safariHilightedAa.png';
import safariPermissionsBlocked from '../../assets/images/safariPermissionsBlocked.png';
import safariLocationToggle from '../../assets/images/safariLocationToggle.png';
import safariAllowLocation from '../../assets/images/safariAllowLocation.png';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { FormattedMessage } from 'react-intl';

const GeolocationInstructions = () => {
    const { precheckInfo } = useContext(PrecheckContext);

    const { orgCode } = precheckInfo;

    const getBrowserAgent = () => {
        const userAgent = navigator.userAgent;
        if (/Chrome/.test(userAgent)) {
            return 'Chrome';
        } else if (/Safari/.test(userAgent)) {
            return 'Safari';
        } else {
            return 'Unknown';
        }
    };

    return (
        <>
            <h2 className="my-4 text-center">{`Enable Location for ${getBrowserAgent()}`}</h2>
            <div className="d-flex flex-column justify-content-evenly m-4">
                {getBrowserAgent() === 'Chrome' ? (
                    <>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center ">
                                <FormattedMessage
                                    id="geolocationInstructionsChromeOne"
                                    defaultMessage="1. Tap the lock icon"
                                />
                            </p>
                            <img className="w-100 rounded" src={chromeHilightedLock} alt="" />
                        </div>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center">
                                <FormattedMessage
                                    id="geolocationInstructionsChromeTwo"
                                    defaultMessage='2. Tap "Permissions"'
                                />
                            </p>
                            <img className="w-100 rounded" src={chromePermissionsBlocked} alt="" />
                        </div>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center">
                                <FormattedMessage
                                    id="geolocationInstructionsChromeThree"
                                    defaultMessage='3. Toggle "Location" on'
                                />
                            </p>
                            <img className="w-100 rounded" src={chromeLocationToggle} alt="" />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center ">
                                1. Tap the &quot;<span style={{ fontSize: '.75rem' }}>A</span>
                                A&quot; icon
                            </p>
                            <img className="w-100 rounded" src={safariHilightedAa} alt="" />
                        </div>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center ">2. Tap &quot;Website Settings&quot;</p>
                            <img className="w-100 rounded" src={safariPermissionsBlocked} alt="" />
                        </div>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center ">3. Tap &quot;Location&quot;</p>
                            <img className="w-100 rounded" src={safariLocationToggle} alt="" />
                        </div>
                        <div className="justify-content-center my-3 border border-dark rounded p-2 bg-white">
                            <p className="text-center ">4. Tap &quot;Allow&quot;</p>
                            <img className="w-100 rounded" src={safariAllowLocation} alt="" />
                        </div>
                    </>
                )}
                <button
                    className="btn md-button m-2"
                    onClick={() => {
                        const url = window.location.origin;
                        window.location.href = `${url}/?org=${orgCode}`;
                    }}>
                    Tap Here to Return to Precheck
                </button>
            </div>
        </>
    );
};

export default GeolocationInstructions;
